import { SelectField } from "ComponentsUI/Selectfield";
import React, { useCallback, useEffect, useState } from "react";
import { generateUrl } from "Services/withDefaultParams";
import { parse } from "query-string";
import { useFilterTypeFromParams } from "./ActionTariffsSortSelect.hooks";
import { useHistory, useLocation, useRouteMatch } from "react-router";
import { createUseStyles } from "react-jss";
import { pipe } from "Utils/index";
import { observer } from "mobx-react";

const getURLForFilterType = (search, match, filterType) => {
	const getParams = parse(search);
	const urlArr = [];

	if (filterType.key) {
		getParams.sort = filterType.key;
	} else {
		delete getParams.sort;
	}

	for (let key in getParams) {
		if (getParams[key]) {
			urlArr.push(`${key}=${getParams[key]}`);
		}
	}

	const providerDetailsUrl = generateUrl(match.path, {
		...match.params,
	});

	return { url: providerDetailsUrl, search: `?${urlArr.join("&")}` };
};

const useStyles = createUseStyles((theme) => ({
	root: {
		width: "280px",
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		root: {
			width: "300px",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		root: {
			width: "230px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			width: "100%",
			paddingTop: "10px",
		},
	},
}));

// TODO: remove ApplicationModel from props on ApplicationModel from store context
const ActionTariffsSortSelect = ({ ApplicationModel, onFilterChange }) => {
	const { root } = useStyles();
	const text = ApplicationModel.text;
	const windowSizes = ApplicationModel.windowSizeModel.windowSizes;

	const match = useRouteMatch();
	const history = useHistory();
	const { search } = useLocation();

	const [filterTypes] = useState([
		{
			id: 1,
			key: "",
			name: text.SORT_BY_POP_1,
			down: true,
		},
		{
			id: 2,
			key: "price.license_fee,id",
			name: text.SORT_BY_PRICE_2,
			down: true,
		},
		{
			id: 3,
			key: "-price.license_fee,id",
			name: text.SORT_BY_PRICE_1,
			up: true,
		},
	]);

	const currentFilterType = useFilterTypeFromParams(filterTypes);

	const onFilterTypeSelect = useCallback(
		([filterType]) => {
			const { search: filterSearch, url } = getURLForFilterType(search, match, filterType);

			history.push({
				pathname: url,
				search: filterSearch,
			});

			onFilterChange(filterType);
		},
		[search, match, history]
	);

	return (
		<div className={root}>
			<SelectField
				findItems={currentFilterType}
				title={text.sorting}
				hideTitleOnMobile
				text={text}
				windowSizes={windowSizes}
				items={filterTypes}
				onlyInputDisabled={true}
				withoutClose={true}
				multiselect={false}
				whiteInput={true}
				onItemSelect={onFilterTypeSelect}
				inputName="sort_tariffs"
			/>
		</div>
	);
};

export default pipe(observer)(ActionTariffsSortSelect);
